import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle `
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 7rem;
  }

  body {
    margin: 0;
    color: ${({ theme }) => theme.colors.ink};
    background: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: 16px;
    line-height: ${({ theme }) => theme.typography.lineHeights.body};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }

  button,
  input,
  textarea,
  select {
    font: inherit;
  }

  button {
    cursor: pointer;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  img {
    display: block;
    max-width: 100%;
  }

  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.blue600};
    outline-offset: 4px;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.white};
  }

  ::selection {
    background: ${({ theme }) => theme.colors.mint200};
    color: ${({ theme }) => theme.colors.navy900};
  }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after {
      animation: none !important;
      transition: none !important;
      scroll-behavior: auto !important;
    }
  }
`;
